import { styled } from 'styled-components';

import SkeletonLine from '../SkeletonLine';

// A single line in the paragraph
export const Line = styled(SkeletonLine)`
  height: var(--font-baseline);
  margin-top: var(--spacing-tiny);
`;
